module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "我们的成长离不开您的支持和建议"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact),
      expression: "contact"
    }],
    attrs: {
      "placeholder": "您的邮箱/QQ/手机号"
    },
    domProps: {
      "value": (_vm.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSend
    }
  }, [_vm._v("发 送")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f4fdd2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/suggest/index.vue
// module id = 325
// module chunks = 0